import { Typography, Box } from "@mui/material";

import CardPaciente from "../../components/CardPaciente";

import { useParams, useNavigate } from "react-router-dom";

import ButtonGoBack from "../../components/Buttons/outlinedGoback";
import AccordionItem from "./AccordionItem";

const styles = {
  title: {
    fontWeight: "600",
    fontSize: "26px",
    lineHeight: "35px",
    margin: "32px 0px",
    color: "#063F5E",
    fontFamily: "Ninuto, sans-serif !important",
  },
  subtitle: {
    fontWeight: "500",
    fontSize: "22px",
    lineHeight: "30px",
    marginBottom: "35px",
    alignSelf: "center",
    color: "#1E729F",
  },
};

export default function ResumoConsulta() {
  const { id } = useParams();
  const navigate = useNavigate();

  return (
    <Box>
      <Box>
        <ButtonGoBack />

        <CardPaciente id={id} />

        <Box component="h1" style={styles.title}>
          Escalas
        </Box>

        <Box
          sx={{
            boxShadow: "0px 1px 8px 0px #00000026",
            padding: "24px",
            borderRadius: "8px",
            marginBottom: "50px",
          }}
        >
          <Typography style={styles.subtitle}>Escalas</Typography>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "40px",
            }}
          >
            <AccordionItem
              AccordionTitle="Neurologia"
              title="Escala Funcional da ELA"
              text="Amyotrophic Lateral Sclerosis Functional Rating Scale (ALSFRS)"
              funRegisterScale={() =>
                navigate(`/escalas/registrar-escala/${id}`)
              }
              funcMonitorEvolution={() => navigate(`/escalas/evolucao/${id}`)}
            />
            <AccordionItem
              AccordionTitle="Nutrição"
              title="Escala de Bristol"
              text="Escala ALS ALS Functional Rating Scale"
            />
            <AccordionItem
              AccordionTitle="Psicologia"
              title="Escala Depressão de Beck"
              text="Escala ALS ALS Functional Rating Scale"
            />
            <AccordionItem
              AccordionTitle="Fonoaudiologia"
              title="Escala Depressão de Beck"
              text="Escala ALS ALS Functional Rating Scale"
            />
            <AccordionItem
              AccordionTitle="Fisioterapia"
              title="Escala de gravidade de fadiga (EGF)"
              text="Escala ALS ALS Functional Rating Scale"
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
